import { render, staticRenderFns } from "./EzChangePassword.vue?vue&type=template&id=2e7b57fa&"
import script from "./EzChangePassword.vue?vue&type=script&lang=js&"
export * from "./EzChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports